import { EventEmitter, Injectable } from '@angular/core';
import { AppProfileService } from '../../core/services/app-profile.service';

@Injectable({
    providedIn: 'root'
})
export class AppProfile {
    onProfileChange = new EventEmitter();

    market: string;
    apiURL: string;
    locale: string;
    epUs: string;
    ampmUs: string;
    env: string;
    ampmPlayground: string;
    org: string;
    tenant: string;

    constructor() {}

    public isMarket(market: string) {
      return this.market !== undefined && this.market.toLowerCase() === market.toLowerCase();
    }

    public getMarket() {
        return this.market;
    }
    public getLocale() {
          return this.locale;
    }

    public load(appProfileService: AppProfileService): Promise<boolean> {
        return new Promise((resolve, reject) => {
            appProfileService.getData().subscribe(
                result => {
                    this.parseJson(result);
                    this.onProfileChange.emit(this);
                    resolve(true);
                },
                error => {
                    reject('Application profile not loaded: ' + error);
                }
            );
        });
    }

    public parseJson(json: any) {
        this.market = json.market;
        this.apiURL = json.apiURL;
        this.locale = json.locale;
        this.epUs = json.epUs;
        this.env = json.env;
        this.ampmUs = json.ampmUs;
        this.ampmPlayground = json.ampmPlayground;
        this.org = json.org;
        this.tenant = json.tenant;
    }
}
